/* eslint-disable formatjs/no-literal-string-in-jsx */

import React, { FunctionComponent } from 'react'
import { Field, Form } from 'react-final-form'
import { View } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { useLyraIntl } from '@lyrahealth-inc/shared-app-logic/src/features/intl/hooks/useLyraIntl'

import { BodyText } from '../../../atoms/bodyText/BodyText'
import { InputFieldRFF } from '../../../atoms/formElements/InputField'
import { SecondaryButton } from '../../../atoms/secondaryButton/SecondaryButton'
import { BodyTextSize } from '../../../styles/typeStyles'
import { tID } from '../../../utils/utils'

const ButtonContainer = styled.View({
  marginBottom: '10px',
})

const TextContainer = styled.View({
  flexDirection: 'row',
  marginBottom: '10px',
})

const LangsListContainer = styled.View({
  marginBottom: '10px',
})

const CurrentInfoContainer = styled.View({
  margin: '5px',
})

export const TranslationsForm: FunctionComponent<TranslationsFormProps> = ({ onSubmit, resetDebugLang, debugLang }) => {
  const { colors } = useTheme()
  const { activeLanguage, availableLanguages, resolved } = useLyraIntl()
  const preferredLanguages = resolved?.preferredLanguages
  return (
    <Form
      initialValues={{ preferredLanguages }}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <View testID={tID('TranslationsForm')}>
          <CurrentInfoContainer>
            {preferredLanguages && (
              <LangsListContainer>
                <BodyText size={BodyTextSize.SMALL} text='Current Device Preferred Languages: ' />
                <BodyText
                  size={BodyTextSize.SMALL}
                  color={colors.textActive}
                  text={preferredLanguages?.join(', ')}
                  wrap
                />
              </LangsListContainer>
            )}
            <TextContainer>
              <BodyText size={BodyTextSize.SMALL} text='Resolved Active Language: ' />
              <BodyText size={BodyTextSize.SMALL} color={colors.textActive} text={activeLanguage} />
            </TextContainer>
            <LangsListContainer>
              <BodyText size={BodyTextSize.SMALL} text='Available Languages: ' />
              <BodyText size={BodyTextSize.SMALL} color={colors.textActive} text={availableLanguages.join(', ')} wrap />
            </LangsListContainer>
            <TextContainer>
              <BodyText size={BodyTextSize.SMALL} text='Current Debug Lang: ' />
              <BodyText size={BodyTextSize.SMALL} color={colors.textActive} text={debugLang} />
            </TextContainer>
          </CurrentInfoContainer>
          <Field
            name='debugLang'
            component={InputFieldRFF}
            autoCapitalize='none'
            placeholder='Set Debug Lang'
            placeholderTextColor={colors.inputTextPlaceholder}
          />
          <ButtonContainer>
            <SecondaryButton isSmall text='Save Debug Lang' onPress={handleSubmit} />
          </ButtonContainer>
          <ButtonContainer>
            <SecondaryButton isSmall text='Clear Debug Lang' onPress={resetDebugLang} />
          </ButtonContainer>
        </View>
      )}
    />
  )
}

type TranslationsFormProps = {
  debugLang: string
  onSubmit: (value: Dict) => void
  resetDebugLang: () => void
}
